<template>
  <div class="photo-page-selector" data-testid="photo-page-selector">
    <v-btn icon small @click="goToFirst" :disabled="value === 0">
      <v-icon small>fa-angle-double-left</v-icon>
    </v-btn>
    <v-btn icon small @click="goToPrevious" :disabled="value === 0">
      <v-icon small>fa-angle-left</v-icon>
    </v-btn>
    <div class="photo-page-selector__display">
      <input
        type="text"
        :value="displayLabel"
        @keyup.enter="handleInput"
        class="photo-page-selector__input"
        ref="input"
      />
      <span class="mx-1">/</span>
      <span class="photo-page-selector__total">{{ max }}</span>
    </div>
    <v-btn icon small @click="goToNext" :disabled="value >= max">
      <v-icon small>fa-angle-right</v-icon>
    </v-btn>
    <v-btn icon small @click="goToLast" :disabled="value >= max">
      <v-icon small>fa-angle-double-right</v-icon>
    </v-btn>
  </div>
</template>

<script>

export default {
  name: 'photo-page-selector',
  props: {
    value: {
      type: Number,
      required: true,
    }, // 現在のインデックス
    max: {
      type: Number,
      required: true,
    },   // 最大インデックス
  },
  computed: {
    displayLabel() {
      return this.value === 0 ? 'tab' : this.value;
    },
  },
  methods: {
    goToFirst() {
      this.$emit('change', 0);
    },
    goToPrevious() {
      if (this.value > 0) {
        this.$emit('change', this.value - 1);
      }
    },
    goToNext() {
      if (this.value < this.max) {
        this.$emit('change', this.value + 1);
      }
    },
    goToLast() {
      this.$emit('change', this.max);
    },
    handleInput(event) {
      const input = event.target.value.trim();
      if (input === 'tab') {
        this.$emit('change', 0);
      } else {
        const num = parseInt(input, 10);
        if (!Number.isNaN(num)) {
          if (num === 0) {
            // 0入力時はtab画像（インデックス0）を表示
            this.$emit('change', 0);
          } else if (num >= 1 && num <= this.max) {
            this.$emit('change', num);
          }
        }
      }
    },
  },
};
</script>

<style scoped lang="sass">
.photo-page-selector
  display: flex
  align-items: center
  gap: 8px

  &__display
    display: flex
    align-items: center
    gap: 4px

  &__input
    width: 42px
    text-align: center
    border: 1px solid #ccc
    border-radius: 4px
    font-size: 14px

  &__total
    font-size: 14px
    color: #666
    width: 16px
    text-align: center
</style>
